(() => {
  if (customElements.get('apollo-full-set')) return;
  class ApolloFullSet extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.choices = [...this.querySelectorAll('[data-pick-box]')];
      this.selection = this.querySelector('[data-selection]');
      this.status = this.querySelector('[data-pick-status]');
      const tray = this.querySelector('[data-box-tray]');
      this.resize = new ResizeObserver(entries => {
        tray.style.setProperty('--tray-scale', Math.min(1.2, entries[0].contentRect.width / 680));
      });
      this.resize.observe(tray);
      const options = { signal: this.controller.signal };
      this.choices.forEach(button => button.addEventListener('click', () => this.pick(button), options));
      this.selection.addEventListener('click', event => { if (event.target.closest('[data-choose-again]')) this.reset(); }, options);
    }
    pick(button) {
      clearTimeout(this.timer);
      const template = this.querySelector(`template[data-candle-template="${button.dataset.pickBox}"]`);
      if (!template) return;
      this.current = button;
      this.choices.forEach(choice => {
        const picked = choice === button;
        choice.classList.toggle('is-picked', picked);
        choice.setAttribute('aria-pressed', String(picked));
      });
      this.selection.replaceChildren(template.content.cloneNode(true));
      this.selection.hidden = false;
      const card = this.selection.querySelector('[data-selected-candle]');
      this.status.textContent = this.dataset.picking;
      const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.timer = setTimeout(() => {
        card.classList.add('is-open');
        card.querySelector('[data-candle-details]').hidden = false;
        card.querySelector('[data-candle-image]').setAttribute('aria-hidden', 'false');
        this.status.textContent = card.dataset.name;
        const rect = this.selection.getBoundingClientRect();
        if (rect.bottom > innerHeight || rect.top < 0) this.selection.scrollIntoView({ behavior: reduced ? 'instant' : 'smooth', block: 'nearest' });
      }, reduced ? 0 : 550);
    }
    reset() {
      clearTimeout(this.timer);
      this.selection.hidden = true;
      this.selection.replaceChildren();
      this.choices.forEach(choice => { choice.classList.remove('is-picked'); choice.setAttribute('aria-pressed', 'false'); });
      this.status.textContent = this.dataset.initial;
      this.current?.focus({ preventScroll: true });
      this.querySelector('[data-box-tray]').scrollIntoView({ behavior: 'instant', block: 'nearest' });
    }
    disconnectedCallback() { this.resize?.disconnect(); clearTimeout(this.timer); this.controller?.abort(); this.controller = null; }
  }
  customElements.define('apollo-full-set', ApolloFullSet);
})();
